import { render, staticRenderFns } from "./removeDialog.vue?vue&type=template&id=509a3e6c&scoped=true&"
import script from "./removeDialog.vue?vue&type=script&lang=js&"
export * from "./removeDialog.vue?vue&type=script&lang=js&"
import style0 from "./removeDialog.vue?vue&type=style&index=0&id=509a3e6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509a3e6c",
  null
  
)

export default component.exports